import DOMPurify from 'dompurify';

export const allowedTags =
  'h1,h2,h3,h4,h5,h6,hgroup,a,blockquote,' +
  'div,hr,li,ol,p,ul,b,br,em,i,q,s,small,span,' +
  'strong,sub,sup,u,caption,col,colgroup,table,tbody,td,tfoot,th,thead,tr';

export const sanitizeHTML = (content: string): string => {
  const sanitized = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: allowedTags.split(','),
    ALLOWED_ATTR: ['style', 'href', 'target', 'rel'],
  });
  return sanitized;
};

// Allow href only on <a>, and ensure target="_blank" is always paired with rel="noopener"
DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  if (data.attrName === 'href' && node.nodeName !== 'A') return null; // remove href from non-<a>
});
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node instanceof HTMLAnchorElement && node.getAttribute('target') === '_blank')
    node.setAttribute('rel', 'noopener');
});

export default sanitizeHTML;
